<template>
  <div class="card">
    <div class="card-body">
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">ID</span>
        <div class="col-sm-8">
          <p>{{ formData.id }}</p>
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">電子メール<span class="required-mark">*</span></span>
        <div class="col-sm-8">
          <input  v-model="formData.email" type="text" class="form-control" required>
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">パスワード</span>
        <div class="col-sm-8">
          <input  v-model="formData.password" type="text" class="form-control" required>
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">パスワードを確認する</span>
        <div class="col-sm-8">
          <input  v-model="formData.password_confirmation" type="text" class="form-control" required>
        </div>
      </div>
      <hr class="my-4">
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">プラン</span>
        <div class="col-sm-8">
          <span style="color: #47AC24;">{{ formData.plan }}</span> <button class="btn btn-sm btn-warning ml-5" @click="planDialog">プランを変更する</button>
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">会社名<span class="required-mark">*</span></span>
        <div class="col-sm-8">
          <input  v-model="formData.company_name" type="text" class="form-control" >
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">法人番号</span>
        <div class="col-sm-8">
          <input  v-model="formData.corporate_number" type="text" class="form-control" >
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">代表者名</span>
        <div class="col-sm-8">
          <select v-model="formData.representative_name" class="form-control">
            <option v-for="(staff) in staff" :key="staff.id" :value="staff.name">{{ staff.name }}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">担当者名</span>
        <div class="col-sm-8">
          <select v-model="formData.contact_person_id" class="form-control">
            <option v-for="(staff) in staff" :key="staff.id" :value="staff.id">{{ staff.name }}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">代表店舗</span>
        <div class="col-sm-8">
          <select v-model="formData.shop_id" class="form-control">
            <option v-for="(shop) in formData.shops" :key="shop.id" :value="shop.id">{{ shop.shop_name }}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">所有店舗</span>
        <div class="col-sm-8">
          <p v-for="(shop) in formData.shops" :key="shop.id">{{ shop.shop_name }}</p>
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">郵便番号<span class="required-mark">*</span></span>
        <div class="col-sm-8">
          <input v-model="formData.postal_code" type="text" placeholder="ハイフンなし数字で入力してください" class="form-control"
                 @keypress="validateNumber" @paste="handlePaste" maxlength="7">
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">住所<span class="required-mark">*</span></span>
        <div class="col-sm-8">
          <textarea v-model="formData.address" class="form-control" rows="3"></textarea>
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">電話番号<span class="required-mark">*</span></span>
        <div class="col-sm-8">
          <input v-model="formData.phone_number" type="text" placeholder="ハイフンなし数字で入力してください" class="form-control"
                 @keypress="validateNumber" @paste="handlePaste">
        </div>
      </div>
      <div class="form-group row">
        <span class="col-sm-2 offset-sm-1 col-form-span font-weight-bold">URL</span>
        <div class="col-sm-8">
          <input  v-model="formData.url" type="text" class="form-control" >
        </div>
      </div>
    </div>
    <div class="card-footer row">
      <div class="col-sm-4 offset-sm-2">
        <button class="btn btn-primary btn-block" @click="dialog">保存</button>
      </div>
      <div class="col-sm-4">
        <button class="btn btn-default btn-block" @click="this.$router.push({name:'CompanyDetailsPage', params: {company_id: id}});">キャンセル</button>
      </div>
    </div>
  </div>

  <!-- 保存確認モーダル -->
  <div v-if="showSaveModal" class="modal-overlay" @click.self="showSaveModal = false">
    <div class="vue-modal">
      <div class="vue-modal-body text-center py-4">
        <p class="mb-1">{{ formData.company_name }} を保存します。</p>
        <p class="text-muted mb-0">よろしいですか？</p>
      </div>
      <div class="vue-modal-footer">
        <button type="button" class="btn btn-outline-secondary" @click="showSaveModal = false">キャンセル</button>
        <button type="button" class="btn btn-primary" @click="register">保存する</button>
      </div>
    </div>
  </div>

  <!-- プラン変更モーダル -->
  <div v-if="showPlanModal" class="modal-overlay" @click.self="showPlanModal = false">
    <div class="vue-modal">
      <div class="vue-modal-body text-center py-4">
        <label class="mb-2" style="font-weight:600;">プランを選択</label>
        <select v-model="formData.plan" class="form-control">
          <option value="フリー">フリー</option>
          <option value="プレミアム">プレミアム</option>
        </select>
      </div>
      <div class="vue-modal-footer">
        <button type="button" class="btn btn-outline-secondary" @click="showPlanModal = false">閉じる</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSaveModal: false,
      showPlanModal: false,
      formData: {
        plan: null,
        status: null,
        name: null,
        corporate_number: null,
        representative_name: null,
        contact_person_id: null,
        representative_store: null,
        shop_id: null,
        postal_code: null,
        address: null,
        phone_number: null,
        url: null,
        email: null,
        password: null,
        password_confirmation: null,
      },
      company: [],
      shops: [],
      staff: [],
    }
  },
  mounted () {
    this.getCompanyDetails();
  },
  methods: {
    validateNumber(event) {
      const key = event.key;
      if (!/[0-9]/.test(key)) event.preventDefault();
    },
    handlePaste(event) {
      const text = (event.clipboardData || window.clipboardData).getData('text');
      if (!/^[0-9]+$/.test(text)) event.preventDefault();
    },
    dialog() {
      this.showSaveModal = true;
    },
    planDialog() {
      this.showPlanModal = true;
    },
    dialogClose() {
      this.showSaveModal = false;
    },
    getCompanyDetails () {
      this.$http.get(process.env.VUE_APP_API_PATH + '/admin/company/' + this.$route.params.company_id)
      .then(response => {
        this.formData = response.data;
        this.formData.email = response.data.user.email
        this.shops = this.formData.shops;
        this.staff = this.formData.staff
      })
      .catch(error => {
        console.log(error);
      });
    },
    validateRequired() {
      // 必須項目チェック (バックエンドより早くフロントで弾く)
      const labelMap = {
        email: '電子メール',
        company_name: '会社名',
        postal_code: '郵便番号',
        address: '住所',
        phone_number: '電話番号',
      };
      const missing = [];
      Object.keys(labelMap).forEach(key => {
        const v = this.formData[key];
        if (v === null || v === undefined || String(v).trim() === '') {
          missing.push(labelMap[key]);
        }
      });
      return missing;
    },
    register() {
      const missing = this.validateRequired();
      if (missing.length > 0) {
        this.$toast.error('未入力の必須項目: ' + missing.join('、'));
        return;
      }
      this.formData.user_id = this.formData.user.id;
      this.$http.put(process.env.VUE_APP_API_PATH + '/admin/company/' + this.$route.params.company_id, this.formData)
      .then(response => {
        this.dialogClose();
        this.$toast.success(response.data.message);
        setTimeout(() => {
          this.$router.push({ name: 'CompanyInfoPage'});
        }, 1000);
        this.getCompanyDetails();
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 422) {
            // サーバ側のバリデーションエラー詳細を表示
            const errors = error.response.data?.errors || error.response.data?.data || {};
            const fields = Object.keys(errors);
            if (fields.length > 0) {
              const labelMap = {
                email: '電子メール', company_name: '会社名', postal_code: '郵便番号',
                address: '住所', phone_number: '電話番号', plan: 'プラン', status: 'ステータス',
              };
              const labels = fields.map(f => labelMap[f] || f);
              this.$toast.error('未入力/不正な項目: ' + labels.join('、'));
            } else {
              this.$toast.error('未入力の必須項目があります');
            }
          } else {
            this.$toast.error(error.response.data?.message || 'エラーが発生しました');
          }
        }
      });
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed; top: 0; left: 0; width: 100%; height: 100%;
  background: rgba(0,0,0,0.4); z-index: 1050;
  display: flex; align-items: center; justify-content: center;
}
.vue-modal {
  background: #fff; border-radius: 12px; width: 360px; max-width: 90vw;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2); overflow: hidden;
}
.vue-modal-body { padding: 20px; }
.vue-modal-footer {
  display: flex; justify-content: center; gap: 12px;
  padding: 12px 20px 20px;
}
.required-mark {
  color: #e53e3e;
  font-weight: 700;
  margin-left: 4px;
}
</style>